import { getPartyIdParam } from '../../../common/src/hooks/query-params/usePartyId';
import { flowIdSalesConversation } from '../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../flows/src/hooks/useFlowsResetState';
import { setSelectionState } from '../utils/persistUtils';
import useSalesConversationFlowPayload from './useSalesConversationFlowPayload';

const useStartSalesConversationFlow = (): ((uuid: string) => Promise<void>) => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();
  const { getFlowPayload } = useSalesConversationFlowPayload();

  return async (uuid?: string) => {
    const partyId = getPartyIdParam();
    const flowPayload = await getFlowPayload(uuid);

    reset();

    const sessionId = await initFlow({
      flowId: flowIdSalesConversation,
      payload: flowPayload,
      inputUrl: partyId
        ? `/product/session?party_id=${partyId}`
        : `/product/session?`,
      outputUrl: `/product/session/finalize`,
      sessionId: uuid,
    });

    if (uuid && sessionId) setSelectionState(sessionId, flowPayload);
  };
};

export default useStartSalesConversationFlow;
